import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { NAV_GROUPS, ROUTES } from "@/content/routes";
import { Mono } from "@/components/site/primitives";
import { cn } from "@/lib/utils";

export const MobileMenu = ({ theme }) => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [pathname]);
  const close = () => setOpen(false);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button type="button" aria-label="Open site navigation" data-testid="mobile-menu-btn" className="border border-o-strong p-2 text-o-text lg:hidden">
          <Menu className="h-5 w-5" />
        </button>
      </SheetTrigger>
      <SheetContent
        side="right"
        aria-describedby={undefined}
        data-testid="mobile-menu"
        className={cn(theme, "w-full overflow-y-auto border-o-line bg-o-bg p-0 text-o-text sm:max-w-md")}
      >
        <SheetTitle className="sr-only">Site navigation</SheetTitle>
        <div className="px-6 pb-10 pt-14">
          {NAV_GROUPS.map((g) => (
            <div key={g.key} className="border-t border-o-line py-5">
              <Mono accent>{g.label}</Mono>
              <ul className="mt-3 space-y-0.5">
                {g.items.map((it) => (
                  <li key={it.key}>
                    <Link
                      to={ROUTES[it.key].path}
                      state={it.via ? { via: it.via } : undefined}
                      onClick={close}
                      data-testid={`mobile-nav-${g.key}-${it.key}`}
                      className="flex items-baseline justify-between gap-4 py-2 text-[15px]"
                    >
                      <span>{it.label}</span>
                      {it.note && <span className="text-right text-xs text-o-dim">{it.note}</span>}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <Link
            to="/engage"
            onClick={close}
            data-testid="mobile-nav-engage"
            className="mt-4 flex w-full items-center justify-between bg-o-accent px-5 py-4 font-medium text-o-accent-ink"
          >
            Engage with Ordo Intelligence
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </SheetContent>
    </Sheet>
  );
};
